module.exports = __webpack_public_path__ + "img/二维码_茂名.c70c5429.png";